module.exports = __webpack_public_path__ + "img/26_181.1da73852.png";